import { render, staticRenderFns } from "./BsCompany.vue?vue&type=template&id=7de93226&scoped=true&"
import script from "./BsCompany.vue?vue&type=script&lang=js&"
export * from "./BsCompany.vue?vue&type=script&lang=js&"
import style0 from "./BsCompany.vue?vue&type=style&index=0&id=7de93226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de93226",
  null
  
)

export default component.exports